<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>

<p-tabView
  [activeIndex]="tab"
  (activeIndexChange)="navigateTab($event)"
  *ngIf="tab !== undefined"
>
  <p-tabPanel header="Calendário">
    <div class="calendar-toolbar">
      <div class="calendar-toolbar__line calendar-toolbar__line--navigation">
        <p-button
          label="Mês"
          [outlined]="view !== CalendarView.Month"
          (onClick)="setView(CalendarView.Month)"
          size="small"
        />
        <p-button
          label="Semana"
          [outlined]="view !== CalendarView.Week"
          (onClick)="setView(CalendarView.Week)"
          size="small"
        />
        <p-button
          label="Dia"
          [outlined]="view !== CalendarView.Day"
          (onClick)="setView(CalendarView.Day)"
          size="small"
        />
        <p-button
          icon="pi pi-chevron-left"
          (onClick)="goToPreviousPeriod()"
          severity="secondary"
          [outlined]="true"
          size="small"
        />
        <span class="calendar-title">{{
          viewDate | calendarDate: view + 'ViewTitle' : locale
        }}</span>
        <p-button
          icon="pi pi-chevron-right"
          (onClick)="goToNextPeriod()"
          severity="secondary"
          [outlined]="true"
          size="small"
        />
        <p-button
          label="Hoje"
          severity="secondary"
          [outlined]="true"
          (onClick)="goToToday()"
          size="small"
        />
      </div>

      <div class="calendar-toolbar__line calendar-toolbar__line--actions">
        <span
          class="running-status-badge"
          *ngIf="currentRound?.subscriberCount"
        >
          {{ pendingSubscribersLabel }}
        </span>
        <p-button
          [label]="currentPaymentRoundButtonLabel"
          icon="pi pi-search"
          severity="secondary"
          [outlined]="true"
          (onClick)="viewCurrentPaymentRound()"
          *ngIf="lastRound"
          size="small"
        />
        <!-- <p-button
          label="Iniciar serviços"
          icon="pi pi-play"
          severity="success"
          (onClick)="confirmStart($event)"
          *ngIf="permission() && currentRound && !runningStatus?.running"
          size="small"
        />
        <p-button
          label="Interromper serviços"
          icon="pi pi-pause"
          severity="danger"
          (onClick)="confirmPause($event)"
          *ngIf="permission() && runningStatus?.running"
          size="small"
        /> -->
        <p-button
          label="Salvar agenda"
          icon="pi pi-save"
          (onClick)="saveSchedulers()"
          *ngIf="permission()"
          size="small"
        />
        <p-button
          label="Clonar agenda"
          icon="pi pi-copy"
          severity="warning"
          [pTooltip]="cloneScheduleTooltip"
          tooltipPosition="bottom"
          (onClick)="cloneSchedule()"
          *ngIf="permission()"
          size="small"
        />
      </div>
    </div>

    <div class="calendar-hint">
      Clique em um dia do mês para abrir a visão diária, clique em um horário na
      visão semanal/diária para incluir agendamento, arraste eventos futuros
      para editar data/hora e use o contorno laranja para identificar itens
      ainda não salvos.
    </div>

    <div [ngSwitch]="view">
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="calendarEvents"
        [draggable]="false"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        (eventClicked)="handleEventClick($event)"
        (dayClicked)="onMonthDayClicked($event)"
        (eventTimesChanged)="onEventTimesChanged($event)"
      />
      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="calendarEvents"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        (eventClicked)="handleEventClick($event)"
        (hourSegmentClicked)="onHourSegmentClicked($event)"
        (eventTimesChanged)="onEventTimesChanged($event)"
      />
      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="calendarEvents"
        [locale]="locale"
        (eventClicked)="handleEventClick($event)"
        (hourSegmentClicked)="onHourSegmentClicked($event)"
        (eventTimesChanged)="onEventTimesChanged($event)"
      />
    </div>
  </p-tabPanel>

  <p-tabPanel header="Lista">
    <ng-template pTemplate="content">
      <app-scheduler-jobs-payment-rounds *ngIf="tab === 1" />
    </ng-template>
  </p-tabPanel>

  <p-tabPanel header="Configurações">
    <ng-template pTemplate="content">
      <app-scheduler-jobs-config [permission]="permission" />
    </ng-template>
  </p-tabPanel>

  <p-tabPanel header="Pix agendado">
    <ng-template pTemplate="content">
      <app-scheduler-jobs-pix-report *ngIf="tab === 3" />
    </ng-template>
  </p-tabPanel>

  <p-tabPanel
    [header]="'Jobs Órfãos (' + (orphanSchedulerJobs?.length || 0) + ')'"
  >
    <p>
      Caso seja feito um agendamento direto no GCP sem vínculo com os eventos do
      calendário,<br />
      ele aparecerá aqui para que seja possível identificar e excluir caso
      necessário.
    </p>
    <div *ngIf="orphanSchedulerJobs?.length === 0" class="config-warning">
      Nenhum job órfão encontrado.
    </div>
    <app-table
      *ngIf="orphanSchedulerJobs?.length > 0"
      [lazy]="false"
      [elements]="orphanSchedulerJobs"
      [cols]="orphanSchedulerCols"
      [actionButtons]="orphanSchedulerActions"
      [addButton]="false"
      [exportExcel]="false"
      [exportPdf]="false"
      modelName="jobs órfãos"
    />
  </p-tabPanel>
</p-tabView>
